import React, { useState } from 'react';
import bridge from '@vkontakte/vk-bridge';

const Premium = ({ appearance, onBack, vkUserId, fetchUserData, isMobileApp }) => {
  const [customDays, setCustomDays] = useState('');
  const [expandedId, setExpandedId] = useState(null);

  const plans = [
    { id: 'premium_7', days: 7, title: 'Неделя', votes: 7, oldVotes: 9, votesPerDay: '1.00' },
    { id: 'premium_30', days: 30, title: 'Месяц', votes: 21, oldVotes: 26, votesPerDay: '0.70', highlight: true },
    { id: 'premium_90', days: 90, title: '3 месяца', votes: 57, oldVotes: 67, votesPerDay: '0.63' },
    { id: 'premium_180', days: 180, title: 'Полгода', votes: 100, oldVotes: 117, votesPerDay: '0.56' },
    { id: 'premium_365', days: 365, title: 'Год', votes: 171, oldVotes: 200, votesPerDay: '0.47' }
  ];

  
  

  const handleBuy = (itemId, e) => {
    if (e) e.stopPropagation(); 
    bridge.send("VKWebAppShowOrderBox", { type: "item", item: itemId })
      .then((data) => {
        if (data.success) {
          setTimeout(() => fetchUserData(), 2000); 
        }
      })
      .catch((e) => console.log("Оплата отменена или ошибка", e));
  };

  const handleCustomBuy = () => {
    const days = parseInt(customDays, 10);
    if (isNaN(days) || days < 1) return;
    handleBuy(`premium_custom_${days}`);
  };

  // УМНЫЙ КАЛЬКУЛЯТОР ДНЕЙ (В ГОЛОСАХ)
  const getCustomPriceVotes = (days) => {
    if (!days || isNaN(days) || days < 1) return 0;
    
    let votesPerDay = 1.0; 
    
    if (days >= 365) votesPerDay = 0.47;      
    else if (days >= 180) votesPerDay = 0.55; 
    else if (days >= 90) votesPerDay = 0.63;  
    else if (days >= 30) votesPerDay = 0.70;  

    return Math.ceil(days * votesPerDay); 
  };

  const daysInt = parseInt(customDays, 10);
  const customVotes = getCustomPriceVotes(daysInt);
  const customOldVotes = customVotes > 0 ? Math.ceil(customVotes * 1.17) : 0;
  const customVotesPerDay = customVotes > 0 ? (customVotes / daysInt).toFixed(2) : 0;

  if (isMobileApp) {
    return (
      <div style={{ padding: '24px 16px', textAlign: 'center', color: appearance === 'dark' ? '#fff' : '#000' }}>
        <h2 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '16px' }}>Профиль Premium</h2>
        
        <div style={{ padding: '20px', borderRadius: '16px', backgroundColor: appearance === 'dark' ? '#232324' : '#fff', marginBottom: '24px' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '15px' }}>Статус вашей подписки:</p>
          <b style={{ fontSize: '18px', color: '#4b37ff' }}>Проверяется...</b>
        </div>

        <button onClick={onBack} style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', backgroundColor: '#e6e6e6', color: '#000', fontWeight: 600 }}>
          Вернуться к чатам
        </button>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '24px 16px 80px 16px', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      height: '100%',
      boxSizing: 'border-box',
      backgroundColor: appearance === 'dark' ? '#19191a' : '#f5f5f7',
      overflowY: 'auto'
    }}>
      
      {/* СЛОГАН */}
      <div style={{ textAlign: 'center', marginBottom: '24px', flexShrink: 0 }}>
        <h1 
          key={appearance} 
          style={{ 
            fontSize: '28px', 
            fontWeight: 800, 
            margin: '0 0 8px 0',
            background: appearance === 'dark' ? 'linear-gradient(90deg, #a8c7fa, #c5a8fa)' : 'linear-gradient(90deg, #4b37ff, #ff37b5)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            color: 'transparent'
          }}
        >
          Сними все ограничения!
        </h1>
        <p style={{ margin: 0, fontSize: '15px', color: appearance === 'dark' ? '#aaa' : '#666', lineHeight: 1.4 }}>
          Выбери подписку и получи безлимитный доступ к нейросети и генерации изображений
        </p>
      </div>

      {/* КАТАЛОГ ТАРИФОВ (АККОРДЕОН) */}
      <div style={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: '12px', flexShrink: 0 }}>
        {plans.map(plan => {
          const isExpanded = expandedId === plan.id;

          return (
            <div 
              key={plan.id}
              onClick={() => setExpandedId(isExpanded ? null : plan.id)}
              style={{
                padding: '16px',
                borderRadius: '20px',
                backgroundColor: appearance === 'dark' ? '#232324' : '#ffffff',
                border: plan.highlight 
                  ? `2px solid ${appearance === 'dark' ? '#a8c7fa' : '#4b37ff'}` 
                  : `1px solid ${appearance === 'dark' ? '#333' : '#e1e3e6'}`,
                boxShadow: plan.highlight ? '0 4px 16px rgba(75, 55, 255, 0.15)' : 'none',
                cursor: 'pointer',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.2s ease',
                boxSizing: 'border-box'
              }}
            >
              {plan.highlight && (
                <div style={{
                  position: 'absolute', top: '-12px', right: '20px', 
                  backgroundColor: appearance === 'dark' ? '#a8c7fa' : '#4b37ff',
                  color: appearance === 'dark' ? '#000' : '#fff',
                  fontSize: '12px', fontWeight: 'bold', padding: '4px 10px', borderRadius: '12px'
                }}>
                  ХИТ ПРОДАЖ
                </div>
              )}
              
              {/* ВЕРХНЯЯ ЧАСТЬ */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px' }}>
                    {plan.title} <span style={{ fontSize: '14px', fontWeight: 400, opacity: 0.6 }}>({plan.days} дней)</span>
                  </span>
                  <span style={{ fontSize: '13px', color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', fontWeight: 500 }}>
                    ≈ {plan.votesPerDay} гол. / день
                  </span>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <span style={{ fontSize: '13px', textDecoration: 'line-through', color: appearance === 'dark' ? '#666' : '#999', marginBottom: '2px' }}>
                    {plan.oldVotes} голосов
                  </span>
                  <span style={{ fontSize: '18px', fontWeight: 800 }}>
                    {plan.votes} <span style={{ fontSize: '14px', fontWeight: 600 }}>голосов</span>
                  </span>
                </div>
              </div>

              {/* НИЖНЯЯ ЧАСТЬ (Раскрывается) */}
              {isExpanded && (
                <div style={{ 
                  marginTop: '16px', 
                  paddingTop: '16px', 
                  borderTop: `1px solid ${appearance === 'dark' ? '#444' : '#eee'}`,
                  animation: 'fadeIn 0.3s ease'
                }}>
                  <ul style={{ margin: '0 0 16px 16px', padding: 0, fontSize: '14px', lineHeight: 1.6, color: appearance === 'dark' ? '#ddd' : '#333' }}>
                    <li>Безлимит токенов</li>
                    <li>Безлимит генерации фото</li>
                  </ul>
                  <button 
                    onClick={(e) => handleBuy(plan.id, e)}
                    style={{
                      width: '100%', padding: '14px', borderRadius: '12px', border: 'none',
                      backgroundColor: appearance === 'dark' ? '#a8c7fa' : '#4b37ff',
                      color: appearance === 'dark' ? '#000' : '#fff',
                      fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(75, 55, 255, 0.2)',
                      transition: 'transform 0.1s'
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
                    onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    Купить за {plan.votes} голосов
                  </button>
                </div>
              )}
            </div>
          );
        })}

        {/* СВОЙ ПЕРИОД (Адаптивный блок) */}
        <div style={{
          padding: '16px',
          borderRadius: '20px',
          backgroundColor: appearance === 'dark' ? '#232324' : '#ffffff',
          border: `1px solid ${appearance === 'dark' ? '#333' : '#e1e3e6'}`,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          boxSizing: 'border-box',
          width: '100%'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 700 }}>Свой период</div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>
            <input 
              type="number" 
              placeholder="Дней" 
              value={customDays}
              onChange={(e) => setCustomDays(e.target.value)}
              style={{
                flex: 1, minWidth: '70px', padding: '12px', borderRadius: '10px', border: `1px solid ${appearance === 'dark' ? '#444' : '#ddd'}`,
                backgroundColor: appearance === 'dark' ? '#19191a' : '#f5f5f7', color: appearance === 'dark' ? '#fff' : '#000',
                fontSize: '15px', outline: 'none', boxSizing: 'border-box'
              }}
            />
            {customVotes > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '70px', flexShrink: 0 }}>
                <span style={{ fontSize: '11px', color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', fontWeight: 500 }}>≈ {customVotesPerDay} гол./д</span>
                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{customVotes} гол.</span>
              </div>
            )}
            <button 
              onClick={handleCustomBuy}
              disabled={!customDays || customDays < 1}
              style={{
                flexShrink: 0, padding: '12px 16px', borderRadius: '10px', border: 'none',
                backgroundColor: (!customDays || customDays < 1) ? (appearance === 'dark' ? '#444' : '#ccc') : (appearance === 'dark' ? '#a8c7fa' : '#4b37ff'),
                color: (!customDays || customDays < 1) ? (appearance === 'dark' ? '#777' : '#fff') : (appearance === 'dark' ? '#000' : '#fff'),
                fontWeight: 'bold', cursor: (!customDays || customDays < 1) ? 'default' : 'pointer'
              }}
            >
              Купить
            </button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1 }}></div>

      {/* НИЖНИЙ БЛОК */}
      <div style={{ marginTop: '32px', width: '100%', maxWidth: '400px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <button 
          onClick={onBack}
          style={{
            width: '100%', padding: '16px', borderRadius: '14px', marginBottom: '16px',
            backgroundColor: appearance === 'dark' ? '#2f2f31' : '#e6e6e6', border: 'none',
            color: appearance === 'dark' ? '#fff' : '#000', fontSize: '16px', fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          Вернуться к чатам
        </button>

        <div style={{ 
          fontSize: '11px', 
          color: appearance === 'dark' ? '#666' : '#999', 
          textAlign: 'center',
          lineHeight: 1.4,
          padding: '0 10px',
          marginTop: '16px'
        }}>
          Оплата производится Голосами ВКонтакте. После активации цифрового товара, подписка возврату и отмене не подлежит.<br/><br/>
          
          Оплачивая подписку, вы соглашаетесь с{' '}
          <a href="https://dev.vk.com/ru/user-agreement" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>
            Пользовательским соглашением
          </a>{' '}
          и{' '}
          <a href="https://dev.vk.com/ru/privacy-policy" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>
            Политикой конфиденциальности
          </a>.<br/><br/>

          <b>Информация о продавце:</b><br/>
          Самозанятый Ненько Макар Владиславович<br/>
          ИНН: 121524446992<br/>
          Email: ma.nenko@mail.ru<br/>
          Служба поддержки: <a href="https://vk.com/free_chat_gpt" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>vk.com/free_chat_gpt</a>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Premium;